import React from "react";

function ParameterValueField({ value, onChange, disabled }) {

    return (
        <div className="oct-shared-popup__field">
            <label className="oct-shared-popup__label" htmlFor="parameter-value">
                Parameter Value <span className="oct-shared-popup__required-mark">*</span>
            </label>
            <input
                className="oct-shared-popup__input"
                id="parameter-value"
                value={value}
                autoComplete="off"
                disabled={disabled}
                placeholder="Enter parameter value"
                onChange={event => onChange(event.target.value)}
            />
        </div>
    )

}

export default ParameterValueField;
